var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"dense":""}},[_c('v-col',{staticClass:"text-center"},[_c('p',{staticClass:"caption font-weight-light"},[_vm._v("Breeze Connect Online Payment Page v"+_vm._s(_vm.appVersion))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }